import { apiUrl } from '../config/apiBase';
import { publicAsset } from '../config/publicAsset';

/** 3.0 children_default.jpg */
export const DONATION_CHILDREN_DEFAULT_IMAGE = publicAsset('/images/info/children_default.jpg');

/**
 * @param {unknown} fileId
 */
export function hasDonationFileId(fileId) {
  return fileId != null && String(fileId).trim() !== '';
}

/**
 * @param {unknown} fileId
 */
export function donationFileImageSrc(fileId) {
  if (!hasDonationFileId(fileId)) {
    return DONATION_CHILDREN_DEFAULT_IMAGE;
  }
  return apiUrl(`/api/files/image?id=${encodeURIComponent(String(fileId).trim())}`);
}

/** 3.0 HTML 본문·스타일에 들어 있는 `file/image?id=` 경로 (DB 변경 없이 표시용 치환) */
const LEGACY_FILE_IMAGE_IN_HTML =
  /(?:https?:\/\/[^"'()\s>]+)?\/?(?:[^"'()\s>/]+\/)*file\/image\?id=([^"'&\s<>]+)/gi;

/**
 * 3.0 에디터 HTML의 `file/image?id={fileId}` 를 4.0 `/api/files/image?id=` 로 치환한다.
 * 상대 경로는 현재 페이지 URL에 붙어 `/info/donation/story/file/image?...` 로 요청되므로 렌더 전에 변환한다.
 * @param {string} html
 */
export function rewriteLegacyFileImageUrlsInHtml(html) {
  if (!html) return '';
  return String(html).replace(LEGACY_FILE_IMAGE_IN_HTML, (_, fileId) =>
    donationFileImageSrc(fileId)
  );
}

/**
 * 3.0 limitTo:140
 * @param {string} text
 * @param {number} max
 */
export function truncateDonationText(text, max = 140) {
  const s = String(text ?? '').trim();
  if (s.length <= max) return s;
  return `${s.slice(0, max)}…`;
}

/**
 * @param {string} cont
 */
export function splitDonationContLines(cont) {
  const s = String(cont ?? '');
  if (!s) return [];
  return s.split(/\r?\n/g);
}

/**
 * @param {string|Date} value
 */
export function formatDonationDate(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}.${m}.${day}`;
}
